export const grayText = "CARTA DE CONSENTIMIENTO BAJO INFORMACIÓN AUTORIZACIÓN DE TRATAMIENTO FARMACOLOGICO APLICACIÓN INTRANASAL DE ESKETAMINA (SPRAVATO) CIDERALT SA DE CV";

export const paragraph1 = "De acuerdo al reglamento de la Ley General de Salud en materia de Presentación de Atención Medica, Capítulo IV Artículos 80, 81, 82 y la NOM. 004-SSA3-2012 del Expediente clínico numeral 10.1, 10.1.1, 10.1.1.1, 10.1.1.2, 10.1.1.3, 10.1.1.4, 10.1.1.5, 10.1.1.6, 10.1.1.7, 10.1.1.8, 10.1.1.9, 10.1.1.10. "

export const paragraph2 = "El suscrito (paciente) _________________________________ o familiar responsable __________________________________________ del paciente con número de expediente ______________________ del servicio de ________________________."

export const paragraph3 = "Autoriza sea aplicado el tratamiento farmacológico INTRANASAL DE ESKETAMINA (SPRAVATO) de acuerdo a las indicaciones del médico tratante, el cual, en un lenguaje claro y sencillo, que he comprendido, me han expuesto debidamente de los posibles riesgos que dicho tratamiento lleva implícito, así como, de las complicaciones mayores y menores, que puedan surgir y que requieran procedimientos y/o tratamientos complementarios que incrementen la estancia o el traslado a otra institución. "

/**
 * Description of the administration procedure and dosage requirements for Esketamine.
 */

export const paragraph4 = "La aplicación consiste en inhalar esketamina (SPRAVATO) aerosol nasal 28mg por dispositivo, de acuerdo a la patología a tratar será el numero de dispositivos por sesión "
export const paragraph5 = "Se me ha informado que algunos de los síntomas adversos posteriores a la inhalación de la esketamina pueden ser entre otros: la disociación, la elevación de la presión arterial, posibles efectos como cambios emocionales, alucinaciones visuales o auditivas, náusea, mareo. Los síntomas adversos se retiran a su totalidad en un aproximado de 60 minutos previo a la administración del medicamento. Así como otros posibles eventos adversos explicados verbalmente por el médico tratante."
export const paragraph6 = "El médico me ha permitido realizar todas las observaciones y me ha aclarado todas las dudas que le he planteado. Por ello manifiesto que estoy satisfecho (a) con la información reciba que comprendo el alcance y los riesgos de este tratamiento, por lo que, en tales condiciones consiento que sea aplicada el mismo. "
export const paragraph7 = "Asimismo, autorizo al médico tratante para que atienda las contingencias derivadas de este tratamiento. "
export const paragraph8 = "Declaro libremente que estoy de acuerdo en participar en esta intervención médica cuyo objetivo, procedimientos y beneficios me fueron especificados, así mismo autorizo al grupo de profesionistas que participan en mi diagnóstico y tratamiento, a aplicar las técnicas de intervención pertinentes y mi caso sea supervisado. "
export const paragraph9 = "Se me ha manifestado que puedo retirar mi consentimiento en cualquier momento, sin que ello signifique que la intervención médica que se me proporciona, se vea afectada por este hecho."
export const paragraph10 = "Se me ha informado que el dar mi consentimiento toda información que se obtenga sobre mi identidad será estrictamente confidencial y solo usada con fines académicos y estadísticos. "
export const grayText2 = "CARTA DE CONSENTIMIENTO BAJO INFORMACIÓN \n AUTORIZACIÓN DE TRATAMIENTO FARMACOLÓGICO \n APLICACIÓN INTRANASAL DE ESKETAMINA (SPRAVATO)"
export const paragraph11 = "Esta autorización inicial no excluye la necesidad de recabar después la correspondiente a cada procedimiento que entrañe un alto riesgo para el paciente. "
export const paragraph12 = "Artículo 80.- En todo Hospital o establecimiento médico y siempre que el estado del paciente lo permita, deberá recabarse a su ingreso, autorización escrita y firmada para practicarle con fines de diagnóstico terapéutico necesario, de acuerdo al padecimiento de que se trate, debiendo informarle claramente el tipo de documento que se le presenta para su firma."
export const paragraph13 = "Artículo 81.- En caso de urgencia o cuando el paciente se encuentre en estado de incapacidad transitoria o permanente, el documento a que se refiere el Artículo anterior, será suscrito por el familiar más cercano en el vínculo que lo acompañe o en su caso, por su Tutor o Representante Legal, una vez informado el carácter de la autorización. Cuando no sea posible obtener la autorización por incapacidad del paciente y ausencia de las personas a las que se refiere el párrafo que antecede, los Médicos autorizados, previa valoración del caso con el acuerdo de que por lo menos dos de ellos, llevarán a cabo el procedimiento terapéutico que el caso requiera, dejando constancia por escrito en el Expediente Clínico."
export const paragraph14 = "Artículo 82.- El documento en el que conste la autorización al que se refieren los Artículos 80 y 81 de este Reglamento, deberán contener:"
export const paragraph15 = ""
export const paragraph16 = ""
export const paragraph17 = ""
export const paragraph18 = ""
export const paragraph19 = ""
export const paragraph20 = ""
export const paragraph21 = ""
export const paragraph22 = ""
export const paragraph23 = ""
export const paragraph24 = ""
export const paragraph25 = ""
export const paragraph26 = ""
export const paragraph27 = ""
export const paragraph28 = ""
export const paragraph29 = ""
export const paragraph30 = ""
export const paragraph31 = ""
export const paragraph32 = ""
export const paragraph33 = ""
export const paragraph34 = ""
export const paragraph35 = ""
export const paragraph36 = ""
export const paragraph37 = ""
export const paragraph38 = ""
export const paragraph39 = ""
export const paragraph40 = ""
export const paragraph41 = ""
export const paragraph42 = ""
export const paragraph43 = ""
export const paragraph44 = ""
export const paragraph45 = ""
export const paragraph46 = ""
export const paragraph47 = ""
export const paragraph48 = ""
export const paragraph49 = ""
export const paragraph50 = ""
export const paragraph51 = ""
export const paragraph52 = ""
export const paragraph53 = ""
export const paragraph54 = ""
export const paragraph55 = ""
export const paragraph56 = ""
export const paragraph57 = ""
export const paragraph58 = ""
export const paragraph59 = ""
export const paragraph60 = ""
export const paragraph61 = ""
export const paragraph62 = ""
export const paragraph63 = ""
export const paragraph64 = ""
export const paragraph65 = ""
export const paragraph66 = ""
export const paragraph67 = ""
export const paragraph68 = ""
export const paragraph69 = ""
export const paragraph70 = ""
export const paragraph71 = ""
export const paragraph72 = ""
export const paragraph73 = ""
export const paragraph74 = ""
export const paragraph75 = ""
export const paragraph76 = ""
export const paragraph77 = ""
export const paragraph78 = ""
export const paragraph79 = ""
export const paragraph80 = ""
export const paragraph81 = ""
export const paragraph82 = ""
export const paragraph83 = ""
export const paragraph84 = ""
export const paragraph85 = ""
export const paragraph86 = ""
export const paragraph87 = ""
export const paragraph88 = ""
export const paragraph89 = ""
export const paragraph90 = ""
export const paragraph91 = ""
export const paragraph92 = ""
export const paragraph93 = ""
export const paragraph94 = ""
export const paragraph95 = ""
export const paragraph96 = ""
export const paragraph97 = ""
export const paragraph98 = ""
export const paragraph99 = ""
export const paragraph100 = ""
